<div
    class="info-study-container"
    *ngIf="opened"
    (click)="close()">

    <div
        class="info-study-modal"
        role="dialog"
        aria-modal="true"
        (click)="$event.stopPropagation()">

        <div class="modal-header">

            <h3 class="modal-title">
                Información del estudio
            </h3>

            <button
                class="close-btn"
                type="button"
                (click)="close()">

                <span class="material-icons">
                    close
                </span>

            </button>

        </div>

        <div class="modal-divider"></div>

        <div class="modal-body">

            <div class="info-row">

                <span class="info-label">
                    {{ 'MENU.INFO_DATA.PATIENT' | translate }}
                </span>

                <span class="info-value">
                     {{bookStudies[0].patientName ?? ' - '}}
                </span>

            </div>

            <div class="info-row">

                <span class="info-label">
                    {{ 'MENU.INFO_DATA.DESCRITPION' | translate }}
                </span>

                <span
                    class="info-value"
                    *ngIf="bookStudies.length === 1">

                    {{bookStudies[0].description ?? 'Sin descripción'}}

                </span>

            </div>

            <div
                class="study-list"
                *ngIf="bookStudies.length > 1">

                <div
                    class="study-item"
                    *ngFor="let s of bookStudies">

                    <span>
                        {{s.description ?? 'Sin descripción'}}
                    </span>

                    <span class="study-date">
                        {{s.studyDate ? (s.studyDate | date:'dd/MM/yyyy') : 'Sin fecha'}}
                    </span>

                </div>

            </div>

            <div class="info-row">

                <span class="info-label">
                    {{ 'MENU.INFO_DATA.LOCATOR' | translate }}
                </span>

                <span class="locator-value">
                    {{ locator }}
                </span>

            </div>

            <div class="info-row">

                <span class="info-value">
                    {{ 'MENU.INFO_DATA.CADUCITY' | translate }} {{ caducityTime ? (caducityTime | date:'mediumDate':'UTC':'es') : ' - ' }}
                </span>

            </div>

        </div>

    </div>

</div>